import type { LocaleCatalog } from '../types';

export const zhCN: LocaleCatalog = {
  'consult_prompt.title': '转接提示音',
  'consult_prompt.help': '固定提示音只生成一次，验证成功后平台复用。转接时客户听提示和等待音乐，原坐席听回铃，同事接入后恢复三方通话。',
  'consult_prompt.ready': '已就绪，可复用',
  'consult_prompt.pending': '尚未准备',
  'consult_prompt.prepare': '生成固定提示音',
  'consult_prompt.confirm': '生成并核验',
  'consult_prompt.cancel': '取消',
  'consult_prompt.billing': '首次生成按当前管理员账户的正常 TTS 规则计费，已有有效资产直接复用；每通转接不会重复合成。不会修改企业的客服流程或通话音频设置。',
  'consult_prompt.reason': '操作原因（至少4个字符）',
  'consult_prompt.failed': '提示音准备失败，请核对后重试',
  'roles.permission_directory': '权限目录',
  'roles.permission_column': "权限数量",
  'roles.permission_count': "{count} 项",
  'roles.risk_column': "权限风险等级",
  'roles.risk_explanation': "按此角色拥有的权限统计。数字表示该等级权限的数量，不表示账号存在异常。",
  'roles.risk_count': "{risk} · {count} 项",
  'roles.risk.R0': "基础信息",
  'roles.risk.R1': "低风险",
  'roles.risk.R2': "一般风险",
  'roles.risk.R3': "高风险",
  'roles.risk.R4': "最高风险",
  'roles.risk.unknown': "等级待确认",
  'roles.no_permissions': "尚未分配权限",
  'roles.all_permissions': "全部（系统内置）",
  'roles.builtin_risk': "包含全部风险等级",
  'roles.builtin_explanation': "超级管理员拥有系统内置的全部管理员权限，无需逐项勾选。充值等最高风险操作仍须完成当前设备的身份复核。",
  'roles.template_title': "这里设置的是岗位权限模板",
  'roles.template_help': "勾选的变更保存前不生效。保存后，只有获得此岗位授权、账号正常且授权未到期的管理员才会继承权限；操作还受数据范围和身份复核限制。当前岗位授权记录：{count} 条。",
  'identity.required': "创建管理员前需要验证当前身份",
  'identity.steps': "你已有管理员岗位权限，但当前设备尚未完成身份复核。输入验证器的 6 位动态码后，即可搜索用户和提交创建申请。",
  'identity.setup': "请先在“登录与安全”登记身份验证器，完成后回到这里点击“重新检查身份”。",
  'identity.verify': "验证并继续",
  'identity.recheck': "重新检查身份",
  'identity.failed': "身份验证未完成",
  'identity.reason': "创建管理员前完成身份复核",
  'identity.search_failed': "平台用户搜索失败",
  'topup.lost_authenticator': "验证器丢失时，请联系仍能验证的安全管理员处理重置；若全员都无法验证，需要由系统负责人进行独立的运维恢复，不能继续走动态码审批。",
  'topup.security_link': "登录与安全",
  'topup.title': "充值算力",
  'topup.title_user': "给「{name}」充值算力",
  'topup.submit': "确认充值",
  'topup.cancel': "取消",
  'topup.amount': "充值数量",
  'topup.reason': "充值原因（4–500 个字，必填）",
  'topup.checking': "正在检查身份验证状态…",
  'topup.setup_required': "充值前需要登记身份验证器",
  'topup.setup_steps': "点击“设置身份验证器”，输入登录密码，用手机身份验证器扫描二维码并输入 6 位动态码。设置完成后回到此弹窗点击“已设置，重新检查”；充值数量和备注会保留。",
  'topup.setup_link': "设置身份验证器",
  'topup.refresh': "已设置，重新检查",
  'topup.verify_required': "充值前请验证当前管理员身份",
  'topup.verify_steps': "输入手机身份验证器当前显示的 6 位动态码，再点击“确认充值”。验证通过后继续本次充值，无需离开此页面。",
  'topup.code': "身份验证器的 6 位动态码",
  'topup.failed': "充值未完成",
  'topup.user_required': "请先选择用户",
  'topup.amount_required': "请输入大于或等于 0.01 的充值数量",
  'topup.reason_required': "请填写 4–500 个字的充值原因",
  'topup.code_required': "请输入身份验证器当前显示的 6 位数字",
  'topup.success': "算力已充值",
  'topup.reload_failed': "充值已完成，但列表刷新失败，请手动刷新",
  'common.loading': '正在加载…',
  'common.page_loading': '正在加载页面…',
  'auth.permission_loading': '正在核验管理员权限…',
  'errors.permission_load_failed': '权限信息加载失败',
  'errors.permission_unavailable': '暂时无法读取管理员权限，请重新核验。',
  'auth.check_again': '重新核验',
  'auth.sign_out': '退出登录',
  'common.language_follow_system': '跟随系统',
  'common.language_user_selected': '手动选择',
  'common.language': '语言',
  'common.language_zh_cn': '简体中文',
  'common.language_zh_tw': '繁體中文',
  'common.language_en_us': 'English',
};
